import { createAsyncThunk } from '@reduxjs/toolkit'
import planningServiceAPI from '../../apis/PlanningServiceAPI'
import { forceManualRecaptcha, ParcelData, RecaptchaAction, RecaptchaPayload } from '../../common/slice'
import { RootState } from '../../common/store'
import { PayloadAction } from '../../common/types'
import RecaptchaRequiredError from '../../errors/RecaptchaRequiredError'


// Action Types
export const UPDATE_PLANNING_DATA = 'UPDATE_PLANNING_DATA'
export const RESET_PLANNING_DATA = 'RESET_PLANNING_DATA'
export const SELECT_PLANNING_PARCEL = 'SELECT_PLANNING_PARCEL'
export const UPDATE_PLANNING_SEARCH_VALUE = 'UPDATE_PLANNING_SEARCH_VALUE'
export const RESET_PLANNING_SEARCH_VALUE = 'RESET_PLANNING_SEARCH_VALUE'

// Selectors
export const getPlanningData = (state: RootState) => {
  return state.planningData
}

export const getPlanningSearchValue = (state: RootState) => {
  return state.planningSearchValue
}

// Actions
export const updatePlanningData = (planningData: PlanningDataRoot) => {
  return {
    type: UPDATE_PLANNING_DATA,
    payload: planningData,
  }
}

export const resetPlanningData = () => {
  return {
    type: RESET_PLANNING_DATA,
  }
}

export const selectPlanningParcel = createAsyncThunk(
  SELECT_PLANNING_PARCEL,
  async (selectedParcel: SelectedParcelProps, thunkAPI) => {
    try {
      const payload = await planningServiceAPI.fetchPlanningData(selectedParcel)
      if (payload) {
        thunkAPI.dispatch(updatePlanningData(payload))
      }
    } catch (e) {
      if (e instanceof RecaptchaRequiredError) {
        const action: RecaptchaAction<SelectedParcelProps> = {
          type: SELECT_PLANNING_PARCEL,
          payload: selectedParcel,
        }
        thunkAPI.dispatch(forceManualRecaptcha(action))
      } else {
        throw e
      }
    }
  })

// Types

export interface SelectedParcelProps extends RecaptchaPayload {
  LAISKEY: string
}

export interface PlanningData extends ParcelData {
  error: boolean
  errorType?: string
  errorMessage?: string
  planningSchemeZone?: string
  overlays?: string[]
  strategicFrameworks?: StrategicPlanData
  interimDevelopmentControlOrders?: string[]
  lastUpdateTime?: number
}

export interface PlanningAppData {
  appId: number
  applicationPurpose?: string
  applicationStatus?: string
  instrumentSigned?: string
  instrumentNumber?: string
  docsAvailable?: string
}

export interface StrategicPlanData {
  regionalPlans: string[]
  subRegionalPlans: string[]
  areaPlans: string[]
  noPlans?: boolean
}

export type PlanningDataRoot = {
  parcelPlanningItem?: PlanningData
  parcelNeighbourItems?: PlanningData[]
  error?: boolean
  errorType?: string
  errorMessage?: string
  lastUpdateTime?: number
}


//Reducers
export const updatePlanningDataReducer = (planningData: PlanningDataRoot | null = null, action: PayloadAction<PlanningDataRoot>) => {

  if (action.type === UPDATE_PLANNING_DATA) {
    return action.payload
  }

  if (action.type === RESET_PLANNING_DATA) {
    return null
  }

  return planningData
}

export const updatePlanningSearchValue = (planningSearchValue?: string) => {
  return {
    type: UPDATE_PLANNING_SEARCH_VALUE,
    payload: planningSearchValue,
  }
}

export const resetPlanningSearchValue = () => {
  return {
    type: RESET_PLANNING_SEARCH_VALUE,
  }
}

export const planningSearchValueReducer = (planningSearchValue = '', { type, payload }: {
  type: string,
  payload: string
}) => {

  if (type === UPDATE_PLANNING_SEARCH_VALUE) {
    return payload
  }

  if (type === RESET_PLANNING_SEARCH_VALUE) {
    return ''
  }

  return planningSearchValue
}

